$(function(){
    
    let flContactName = false;
    let flEmail = false;
    let flCompanyName = false;
    let flPrimarySalesTerritory = false;
    let flSalesChannels = false;
    let flNeed = false;
    let flChecked = false;
    
    const icon = '<svg t="1652168195525" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2038" width="16" height="16"><path d="M512 102.4c225.28 0 409.6 184.32 409.6 409.6s-184.32 409.6-409.6 409.6-409.6-184.32-409.6-409.6 184.32-409.6 409.6-409.6m0-102.4C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z" p-id="2039" fill="#d81e06"></path><path d="M512 256c30.72 0 51.2 20.48 51.2 51.2v204.8c0 30.72-20.48 51.2-51.2 51.2s-51.2-20.48-51.2-51.2V307.2c0-30.72 20.48-51.2 51.2-51.2z" p-id="2040" fill="#d81e06"></path><path d="M512 716.8m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" p-id="2041" fill="#d81e06"></path></svg>'
    const contactName = $("#inputContactName");  
    const email = $("#inputEmail");
    const companyName = $("#inputCompanyName");
    const primarySalesTerritory = $("#inputPrimarySalesTerritory");
    const salesChannels = $("#textareaSalesChannels");
    const need = $("#textareaNeed"); 

    function fnContactName() {
      let vals = contactName.val();
      if (vals == "") {
        contactName.next().show().html(icon + "Please fill in this column");
        flContactName = false;                                         
      } else {
        contactName.next().hide();
        flContactName = true;
      }
    };
    contactName.blur(function () {
        fnContactName();
    });
    function fnEmail() {
      let vals = email.val();
      let reMail = /^[a-z0-9][\w\.\-]*@[a-z0-9\-]+(\.[a-z]{2,5}){1,2}$/i;
      if(reMail.test(vals)){
        email.next().hide();
        flEmail = true;
      } else {
        email.next().show().html(icon + "The email format you entered is incorrect")
        flEmail = false;
      }
    };
    email.blur(function () {
        fnEmail();
    });
    function fnCompanyName() {
      let vals = companyName.val();
      if (vals == "") {
        companyName.next().show().html(icon + "Please fill in this column");
        flCompanyName = false;
      } else {
        companyName.next().hide();
        flCompanyName = true;
      }
    };
    companyName.blur(function () {
        fnCompanyName();
    });
    function fnPrimarySalesTerritory() {
      let vals = primarySalesTerritory.val();
      if (vals == "") {
        primarySalesTerritory.next().show().html(icon + "Please fill in this column");
        flPrimarySalesTerritory = false;
      } else {
        primarySalesTerritory.next().hide();
        flPrimarySalesTerritory = true;
      }
    };
    primarySalesTerritory.blur(function () {
        fnPrimarySalesTerritory();
    });
    function fnSalesChannels() {
      let vals = salesChannels.val();
      if (vals == "") {
        salesChannels.next().show().html(icon + "Please fill in this column");
        flSalesChannels = false;
      } else {
        salesChannels.next().hide();
        flSalesChannels = true;
      }
    };
    salesChannels.blur(function () {
        fnSalesChannels();
    });
    function fnNeed() {
      let vals = need.val();
      if (vals == "") {
        need.next().show().html(icon + "Please fill in this column");
        flNeed = false;
      } else {
        need.next().hide();
        flNeed = true;
      }
    };
    need.blur(function () {
        fnNeed();
    });
    function fnchecked() {
      let checked = $("#checks").prop("checked");
      if (checked == true) {
        $("#checks").next().next().next().hide();
        flChecked = true
      } else {
        $("#checks").next().next().next().show().html(icon + "Please fill in this column");
        flChecked = false
      }
    }
    $("#checks").blur(function(){
      fnchecked();
    })
    $("#submits").on("click",function(){
      $("#form").on("submit",function(e){
        e.preventDefault();
        var data =$('#form').serialize();    
        if(flContactName == true&&flEmail == true&&flCompanyName == true&&flPrimarySalesTerritory == true&&flSalesChannels == true&&flNeed == true&&flChecked == true) {
          e.preventDefault();
          $.ajax({
            type: "POST",
            url: "https://www.minyue99.com/shopify/kovol/save-dealer",
            data: data,
            success: function(res){
              if (res.code == 200) {
                window.location.reload();
              } else {
                e.preventDefault();
                email.next().show().html(icon + res.msg)
                alert(res.msg);
                return
              }
            },
          }); 
        } else {
          fnchecked()
          fnNeed();
          fnContactName();
          fnEmail();
          fnCompanyName();
          fnPrimarySalesTerritory();
          fnSalesChannels()
          e.preventDefault();
        }
      })
    })
    
  })